import { Theme, ThemeUICSSObject } from 'theme-ui';
import { focusOutline } from '../../../../util';

const primary: (theme: Theme) => ThemeUICSSObject = (theme) => {
  return {
    /* PREPEND HERE */
    position: 'relative',

    '[role="tree"]:focus': {
      outline: 'none',
      '.focus': focusOutline,
    },

    '&[role="tree"].mobxtree :focus': {
      outline: 'none',
    },
    '&[role="tree"].mobxtree:focus-within': {
      '.focus > .mobxtree__node__label__wrapper': focusOutline,
    },

    ul: {
      listStyle: 'none',
      p: 0,
    },

    '.mobxtree__children__group': {
      borderLeft: '1px dotted',
      borderLeftColor: 'palette.border.section',
      ml: '5px',
      pl: '15px',
    },

    '.tree__searchLabelBox': {
      alignItems: 'center',
      borderRadius: '2px',
      display: 'flex',
      float: 'right',
      justifyContent: 'center',
      position: 'sticky',
      right: '4px',
      top: '4px',
      transform: 'translateX(0)',
      width: '100%',
      zIndex: 'stickyElements',

      '.tree__loading': {
        position: 'fixed',
        top: 0,
        right: '4px',
        height: 'iconMd',
        width: 'iconMd',
        background: 'palette.background.paper',
      },

      button: {
        cursor: 'pointer',

        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },

    '.tree__searchLabel': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      position: 'fixed',
      p: '2px 5px',
      right: 0,
      top: 0,

      ...theme.palette.getOneState(
        { backgroundColor: 'palette.background.paper' },
        'selected',
      ),
    },

    '[role="treeitem"]': {
      '&[aria-expanded="false"] ul': {
        display: 'none',
      },

      '&[aria-selected="true"] > .tree__nodeItemLabel':
        theme.palette.getOneState(
          { backgroundColor: 'palette.background.paper' },
          'selected',
        ),

      background: 'transparent',
    },

    '.mobxtree__node__label': {
      flexGrow: 1,
    },

    '.mobxtree__node__label__icons': {
      flexShrink: 0,
    },

    '.tree__nodeItemLabel, .mobxtree__node__label__wrapper': {
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      wordBreak: 'break-all',

      button: {
        cursor: 'pointer',

        '&:hover': {
          textDecoration: 'underline',
        },

        span: {
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        },
      },

      '.tree__nodeItemLabelRenderer': {
        display: 'flex',
        overflow: ' hidden',
        width: '100%',
      },

      '.button__content': {
        textAlign: 'left',
      },

      '& > *:not(.tree__nodeItemLabelRenderer)': {
        flexShrink: 0,
        textAlign: 'left',
      },

      '&:hover': theme.palette.getOneState(
        { backgroundColor: 'palette.background.paper' },
        'hover',
      ),
    },
    '.tree__expanderWrapper, .mobxtree__node__expander': {
      display: 'inline-flex',
      ml: '-10px',
      pl: '5px',

      'svg.tree__expandIcon, svg.mobxtree__node__expandIcon': {
        color: 'palette.text.primary',
      },
    },

    '.tree__node__icon': {
      mr: '3',
    },

    '.spacer': {
      borderLeft: '1px dotted',
      borderLeftColor: 'palette.border.section',
      width: '20px',
      alignSelf: 'stretch',
      transform: 'translateX(5px)',
      pointerEvents: 'none',
    },
  };
};

export default primary;
